import Vue from 'vue'
import VueRouter from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import routes from './routes'
import store from './store'

// bundle assets
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './static/styles/oscar.scss'
import './static/styles/theme/theme.scss'

// font awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import * as icons from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add([
  icons.faCoffee,
  icons.faArrowLeft,
  icons.faArrowRight,
  icons.faArrowUp,
  icons.faArrowDown,
  icons.faPlus,
  icons.faMinus,
  icons.faTimes,
  icons.faEraser,
  icons.faBars,
  icons.faImage,
  icons.faFont,
  icons.faMinus,
  icons.faEquals,
  icons.faMinusSquare,
  icons.faChevronDown,
  icons.faChevronRight,
  icons.faShareSquare,
  icons.faCheckCircle
])
Vue.component('fa', FontAwesomeIcon)

// TODO: could move this whole thing to a router file
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // only happens on popstate (back/forward button)
    if (savedPosition) {
      return savedPosition
    } else if (to.path === from.path) {
      // don't reset scroll position on sorting changes
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  store.dispatch('restoreUser')

  // Check if referral url exists and set to state
  if (to.query.ref) {
    store.state.referrer = to.query.ref
  }

  // proceed if the route doesn't require auth, or the user is logged in
  if (!to.meta.requiresAuth || store.state.userToken) {
    next()
  } else {
    // Save the path that user was heading to (to redirect after login)
    store.state.redirect = to.path

    // Take user to root which will then take them to login
    next('/')
  }
})

Vue.use(BootstrapVue)

Vue.config.ignoredElements = ['trix-editor']

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})
